import * as _ from 'lodash';
import { fromJS } from 'immutable';
import * as depreciationCategoriesActions from '../actions/depreciationCategories';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  allYears: {
    data: [],
    state: null,
  },
  depreciationCategories: {
    data: [],
    state: null,
  },
  depreciationCategory: {
    data: {},
    state: null,
  },
  depreciationMethods: [],
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case depreciationCategoriesActions.FETCH_ALL_YEARS[START]: {
      return state.setIn(['allYears', 'state'], fetchingState.FETCHING);
    }
    case depreciationCategoriesActions.FETCH_ALL_YEARS[ERROR]: {
      return state.setIn(['allYears', 'state'], fetchingState.ERROR);
    }
    case depreciationCategoriesActions.FETCH_ALL_YEARS[SUCCESS]: {
      return state
        .setIn(['allYears', 'state'], fetchingState.LOADED)
        .setIn(
          ['allYears', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case depreciationCategoriesActions.FETCH_PERSONAL_DEPRECIATION_CATEGORIES[
      START
    ]: {
      return state.setIn(
        ['depreciationCategories', 'state'],
        fetchingState.FETCHING,
      );
    }
    case depreciationCategoriesActions.FETCH_PERSONAL_DEPRECIATION_CATEGORIES[
      ERROR
    ]: {
      return state.setIn(
        ['depreciationCategories', 'state'],
        fetchingState.ERROR,
      );
    }
    case depreciationCategoriesActions.FETCH_PERSONAL_DEPRECIATION_CATEGORIES[
      SUCCESS
    ]: {
      return state
        .setIn(
          ['depreciationCategories', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        )
        .setIn(['depreciationCategories', 'state'], fetchingState.LOADED);
    }

    case depreciationCategoriesActions.FETCH_PERSONAL_DEPRECIATION_CATEGORY[
      START
    ]: {
      return state.setIn(
        ['depreciationCategory', 'state'],
        fetchingState.FETCHING,
      );
    }
    case depreciationCategoriesActions.FETCH_PERSONAL_DEPRECIATION_CATEGORY[
      ERROR
    ]: {
      return state.setIn(
        ['depreciationCategory', 'state'],
        fetchingState.ERROR,
      );
    }
    case depreciationCategoriesActions.FETCH_PERSONAL_DEPRECIATION_CATEGORY[
      SUCCESS
    ]: {
      return state
        .setIn(
          ['depreciationCategory', 'data'],
          fromJS(_.get(action, ['data', 'results', 0], {})),
        )
        .setIn(['depreciationCategory', 'state'], fetchingState.LOADED);
    }

    case depreciationCategoriesActions.FETCH_DEPRECIATION_METHODS[SUCCESS]: {
      return state.setIn(
        ['depreciationMethods'],
        fromJS(_.get(action, ['data', 'results'], [])),
      );
    }

    default: {
      return state;
    }
  }
};
